import apiClient from "./apiClient";

/**
 * BTC 적립(DCA) API (DAS-177).
 *
 * 응답 형태는 `/api/stocks/series`와 동일하다 — `{ points: [{date, principal_krw, value_krw}], snapshot_since }`.
 * 프론트가 해외주식과 같은 `AccumulationChart`를 그대로 재사용하기 위한 계약이므로,
 * 백엔드 응답 모양을 바꿀 때는 두 도메인을 같이 봐야 한다.
 */
export const getSeries = (range = "all") =>
    apiClient.get(`/api/btc/series?range=${encodeURIComponent(range)}`);
